import NavigationBar from "../components/NavigationBar";
import UpdateForgotPasswordForm from "../components/UpdateForgotPasswordForm";
import Footer from "../components/Footer";
function UpdateForgotPasswordPage() {
	return (
		<>
			<NavigationBar />
			<UpdateForgotPasswordForm />
			<Footer />
		</>
	);
}

export default UpdateForgotPasswordPage;
